"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ControlSeparator_1 = require("../controls/ControlSeparator");
var Icon_1 = require("../Icon");
var helpers_1 = require("../helpers");
var StackView_1 = require("../StackView");
var Text_1 = require("../Text");
var SignPost_1 = require("../SignPost");
var View_1 = require("../View");
var BackSvg_1 = require("./icons/BackSvg");
var PAGE_HEADER_TITLE_VIEW;
(function (PAGE_HEADER_TITLE_VIEW) {
    PAGE_HEADER_TITLE_VIEW["row"] = "row";
    PAGE_HEADER_TITLE_VIEW["column"] = "column";
})(PAGE_HEADER_TITLE_VIEW = exports.PAGE_HEADER_TITLE_VIEW || (exports.PAGE_HEADER_TITLE_VIEW = {}));
var BackIcon = styled_components_1.default(BackSvg_1.BackSvg)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    cursor: pointer;\n    color: ", ";\n    width: 100%;\n    height: 100%;\n"], ["\n    cursor: pointer;\n    color: ",
    ";\n    width: 100%;\n    height: 100%;\n"])), function (_a) {
    var isDisabled = _a.isDisabled, theme = _a.theme;
    return isDisabled ? theme.colorControlIconDisabled : theme.colorControlIcon;
});
function PageHeaderSeparator() {
    return react_1.default.createElement(ControlSeparator_1.ControlSeparator, { size: ControlSeparator_1.SEPARATOR_SIZE.xl });
}
exports.PageHeaderSeparator = PageHeaderSeparator;
exports.PageHeader = helpers_1.createUIElement('PageHeader', function (_a, ref) {
    var className = _a.className, subtitle = _a.subtitle, title = _a.title, info = _a.info, secondaryText = _a.secondaryText, _b = _a.hasBack, hasBack = _b === void 0 ? true : _b, _c = _a.disabledBack, disabledBack = _c === void 0 ? false : _c, onBackClick = _a.onBackClick, content = _a.content, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "subtitle", "title", "info", "secondaryText", "hasBack", "disabledBack", "onBackClick", "content", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var doubleTitle = !!subtitle;
    return (react_1.default.createElement(StackView_1.StackView, __assign({}, rest, { testId: rest['data-selector-id'] || 'page-header', className: "vm-PageHeader " + className, direction: StackView_1.STACK_DIRECTION.row, align: StackView_1.STACK_ALIGN.center, indentVertical: View_1.INDENT.s, gap: StackView_1.STACK_GAP.m, size: { height: helpers_1.SIZE_XXL }, distribution: StackView_1.STACK_DISTRIBUTION.lastFill, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        hasBack && (react_1.default.createElement(Icon_1.Icon, { "data-selector-id": "exitbutton", src: react_1.default.createElement(BackIcon, { isDisabled: disabledBack }), size: Icon_1.ICON_SIZES.xl, onClick: function () {
                if (!disabledBack) {
                    onBackClick === null || onBackClick === void 0 ? void 0 : onBackClick();
                }
            } })),
        hasBack && react_1.default.createElement(PageHeaderSeparator, null),
        react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.row, align: StackView_1.STACK_ALIGN.center, gap: StackView_1.STACK_GAP.s, distribution: content ? StackView_1.STACK_DISTRIBUTION.lastFill : StackView_1.STACK_DISTRIBUTION.start },
            react_1.default.createElement(StackView_1.StackView, { direction: doubleTitle ? StackView_1.STACK_DIRECTION.column : StackView_1.STACK_DIRECTION.row, gap: doubleTitle ? StackView_1.STACK_GAP.xs : StackView_1.STACK_GAP.s },
                react_1.default.createElement(StackView_1.StackView, { align: StackView_1.STACK_ALIGN.center, gap: StackView_1.STACK_GAP.s },
                    react_1.default.createElement(Text_1.Text, { size: Text_1.TEXT_SIZE.xl, truncate: true }, title),
                    secondaryText && (react_1.default.createElement(Text_1.Text, { size: Text_1.TEXT_SIZE.xl, view: Text_1.TEXT_VIEW.light, truncate: true }, secondaryText)),
                    info && doubleTitle && react_1.default.createElement(SignPost_1.SignPost, { text: info })),
                subtitle),
            info && !doubleTitle && (react_1.default.createElement(SignPost_1.SignPost, { text: info, positions: [
                    SignPost_1.SIGN_POST_POSITIONS.topRight,
                    SignPost_1.SIGN_POST_POSITIONS.bottomRight
                ] })),
            content && (react_1.default.createElement(StackView_1.StackView, { direction: StackView_1.STACK_DIRECTION.row, align: StackView_1.STACK_ALIGN.center, gap: StackView_1.STACK_GAP.m, spaceLeft: View_1.INDENT.s }, content)))));
});
var templateObject_1;
//# sourceMappingURL=PageHeader.js.map